import { mapState, mapMutations, createNamespacedHelpers } from 'vuex';
import { countDown, conversion  } from '@/tool';
import { format_date } from '@/filters/format_date';
import { format_case_name } from '@/filters/format_case_name';

import CustomButton from '@/partials/custom_button';
import { CustomBlockTitle } from '@/partials/custom_block_title';
import Button from '@/components/button';
import Picture from '@/components/picture';
import BlockPanel from '@/components/block_panel';
import Award from '@/components/award';
import LiveDropBox from '@/partials/live_drop_box';
import NoticeBoard from '@/components/noticeboard/index.vue'
import * as apis from '@/api';

const {
	mapActions: RollRoomsMapActions,
	mapGetters: RollRoomsMapGetters
} = createNamespacedHelpers('roll_rooms');


export default {
	components: {
		'p-custom-button': CustomButton,
		'p-custom-block-title': CustomBlockTitle,
		'p-live-drop-box':LiveDropBox	,
		'c-button': Button,
		'c-picture': Picture,
		'c-block-panel': BlockPanel,
		'c-award': Award,
		'c-notice-board':NoticeBoard
	},

	filters: {
		conversion,
		countDown,
		format_date,
		format_case_name,
	},


	data() { return {
		totalInviteCount:0,
		caseList: [],
	}; },

	computed: {
		...mapState([ "user"]),

	},

	async mounted() {
	},
	
	async created() {
		// 获取首页箱子列表
		this.getFreeboxList();
	},



	methods: {
		pathGo(obj) {
			 this.$router.push({
					name: 'case',
					params: { id: obj.id },
				});
				this.$emit('close_button_click');	
		},
		getFreeboxList() {
			apis.freeboxInfo().then(res=>{
				this.caseList = res.data.data.list;
				this.totalInviteCount = res.data.data.inviteCount;
			});
		},
	},
};
